export const ugovor_o_asignaciji = {
  templateId: 26,
  category: 2,
  templateTitle: "Ugovor o asignaciji",
  templateDescription: `Uputa/asignacija je trostrani ugovor u kojemu jedna osoba, uputitelj (asignant), ovlašćuje drugu osobu, upućenika (asignata), da za njezin račun ispuni nešto određenoj trećoj osobi-primatelju upute (asignataru), a ovoga (asignatara) ovlašćuje da to ispunjenje primi u svoje ime. Za točniji odabir načina reguliranja međusobnih odnosa predlažemo da koristite <a target="_blank" href="http://solucio-debit.com">Solucio Debit app</a>.`,
  description: `
    <h5>OPIS I SVRHA DOKUMENTA</h5>
    <p><strong>Uputom/asignacijom jedna osoba, uputitelj (asignant), ovlašćuje drugu osobu, upućenika (asignata), da za njezin račun ispuni nešto određenoj trećoj osobi-primatelju upute (asignataru), a ovoga (asignatara) ovlašćuje da to ispunjenje primi u svoje ime.</p></strong>
    <p>Ukoliko želite provjeriti hoće li ova vrsta ugovora biti ispravan odabir za međusobno reguliranje odnosa, predlažemo korištenje aplikacije <a target="_blank" href="http://solucio-debit.com">Solucio Debit app</a> koja će brzo i točno dati rješenje za vašu situaciju. </p>
    <p>Asignacija uglavnom proizlazi iz odnosa u kojemu je uputitelj (asignant) vjerovnik upućenika (asignata), a ujedno dužnik primatelja upute odnosno kako slijedi:</p>
    <p>UPUĆENIK (asignat) duguje UPUTITELJU (asignant) &gt; UPUTITELJ (asignant) duguje PRIMATELJU UPUTE (asignataru).</p>
    <p>Davanjem izjave, uputitelj (asignant) se "izmiče" iz postojećeg odnosa, čime se uspostavlja novi odnos između njegovog dužnika (asignata) i vjerovnika (asignatara).</p>
    <p>Iako postoje sličnosti u odnosu na ugovor o preuzimanju duga, cesiju umjesto plaćanja, i cesiju radi naplaćivanja, razlike su sljedeće:</p>
    <table class="table table-bordered">
      <tbody>
        <tr>
          <td>
            <p><strong></strong></p>
          </td>
          <td>
            <p><strong>ASIGNACIJA</strong></p>
          </td>
          <td>
            <p><strong>UGOVOR O PREUZIMANJU DUGA</strong></p>
          </td>
          <td>
            <p><strong>UGOVOR O CESIJI UMJESTO PLAĆANJA</strong></p>
          </td>
          <td>
            <p><strong>UGOVOR O CESIJI RADI ISPUNJENJA (NAPLAĆIVANJA) </strong></p>
          </td>
        </tr>
        <tr>
          <td>
            <p><strong>VRSTA PRAVNOG POSLA</strong></p>
          </td>
          <td>
            <p>trostrani pravni posao</p>
          </td>
          <td>
            <p>trostrani pravni posao</p>
          </td>
          <td>
            <p>dvostrani pravni posao</p>
          </td>
          <td>
            <p>dvostrani pravni posao</p>
          </td>
        </tr>
        <tr>
          <td>
            <p><strong>PROVEDBA</strong></p>
          </td>
          <td>
            <p>za provedbu je potrebna suglasnost svih sudionika</p>
          </td>
          <td>
            <p>za provedbu je potrebna suglasnost svih sudionika</p>
          </td>
          <td>
            <p>za provedbu nije potrebno ishoditi suglasnost dužnika, no potrebno ga je obavijestiti</p>
          </td>
          <td>
            <p>za provedbu nije potrebno ishoditi suglasnost dužnika, no potrebno ga je obavijestiti</p>
          </td>
        </tr>
        <tr>
          <td>
            <p><strong>PRESTANAK OBVEZA OSOBE KOJA JE UJEDNO DUŽNIK I VJEROVNIK</strong></p>
          </td>
          <td>
            <p>ispunjenjem</p>
          </td>
          <td>
            <p>sklapanjem ugovora</p>
          </td>
          <td>
            <p>sklapanjem ugovora</p>
          </td>
          <td>
            <p>ispunjenjem</p>
          </td>
        </tr>
      </tbody>
    </table>
    <p><strong>Ugovorne strane mogu svoje međusobne odnose riješiti ugovorom o cesiji, ugovorom o preuzimanju duga, ali i ugovorom o asignaciji, ovisno o ciljevima koje žele postići.</strong></p>
    <p><strong>Navedene mogućnosti uređenja odnosa izlažu se na primjeru u nastavku:</strong></p>
    <p><strong>Pretpostavimo da u trenutnom odnosu A duguje B, B duguje C, pa je tako:</strong></p>
    <p><strong>A dužnik B, </strong></p>
    <p><strong>B je vjerovnik A, a dužnik C.</strong></p>
    <p>Ugovorne strane mogu svoje međusobne odnose riješiti na sljedeće načine:</p>
    <ol>
      <li>
        <p>Reguliranje međusobnih odnosa kroz cesiju umjesto plaćanja</p>
        <p>B kao cedent (stari vjerovnik) ustupa C (cesionar, novi vjerovnik) svoju tražbinu koju ima prema A (cesus, dužnik), čime podmiruje svoje dugovanje prema C. Sklapanjem ugovora prestaje dugovanje B prema C.</p>
      </li>
      <li>
        <p>Reguliranje međusobnih odnosa kroz cesiju radi ispunjenja (naplaćivanja)</p>
        <p>B kao cedent (stari vjerovnik) ustupa C (cesionar, novi vjerovnik) svoju tražbinu koju ima prema A (cesus, dužnik). Sve međusobne obveze prestaju tek kada A ispuni obvezu prema C, za razliku od cesiju umjesto plaćanja kod koje samim sklapanjem ugovora prestaje dugovanje B prema C.</p>
      </li>
      <li>
        <p>Reguliranje međusobnih odnosa kroz cesiju radi osiguranja</p>
        <p>B kao cedent (stari vjerovnik) ustupa C (cesionaru, novi vjerovnik) svoju tražbinu koju ima prema A (cesus, dužnik), radi osiguranja tražbine C prema B. C je dužan brinuti o naplati ustupljene tražbine, a po naplati višak predati B.</p>
      </li>
      <li>
        <p>Reguliranje međusobnih odnosa kroz preuzimanje duga</p>
        <p>A (kao novi dužnik) preuzima dugovanje B (stari dužnik) prema C (vjerovnik), a kojim preuzimanjem duga se stvara tražbina A prema B koje se potom kompenzira s ranijom protutražbinom B prema A. Obveza B (stari dužnik) prema C više ne postoji između navedenih subjekata, jer je preuzeta ugovorom o preuzimanju duga (A je preuzeo dug od B).</p>
      <li>
        <p>Reguliranje međusobnih odnosa kroz asignaciju</p>
        <p>A (kao upućenik - asignat) na temelju upute B (uputitelja - asignanta) prihvaća ovlast da u ime B podmiri obvezu B prema C, a ujedno C (primatelj upute - asignatar) prima ovlast da ispunjenje primi u svoje ime. Za razliku od cesije umjesto plaćanja i preuzimanja duga, kod ugovora o asignaciji, međusobne obveze prestaju tek s ispunjenjem upute (podmirenjem obveze A, primanjem ispunjenja C).</p>
      </li>
    </ol>
    <p><strong>Dakle, isti poslovni odnos između dužnika i vjerovnika može biti reguliran kroz ugovor o cesiji umjesto ispunjenja/plaćanja, ugovor o cesiji radi ispunjenja (naplaćivanja), ugovor o cesiji radi osiguranja ili kroz ugovor o preuzimanju duga odnosno kroz ugovor o asignaciji, ovisno o poslovnim interesima i dogovoru ugovornih strana.</strong></p>
    
    <p><strong>NAPOMENA: Ovršenik (dužnik) kao poslovni subjekt ne smije  (prema Zakonu o provedbi ovrhe na novčanim sredstvima) sklapati ugovore radi obračunskog plaćanja ako u Jedinstvenom registru računa ima oznaku blokade računa, odnosno zabranu raspolaganja oročenim novčanim sredstvima, ako tim obračunskim plaćanjem kao vjerovnik tražbine (u ovom slučaju, kod asignacije se zabrana odnosi na asignanta, a ne na asignata ili asignatara) onemogućuje ili izbjegava primitak ispunjenja obveze u novcu. Novčana kazna u slučaju kršenja navedenog može biti do 500.000,00 kn. </strong></p>
    <p><strong> Osim toga, sukladno Zakonu o obveznim odnosima takav ugovor je ništetan (ne proizvodi nikakve pravne učinke) jer je protivan prisilnim propisima (Zakon o provedbi ovrhe na novčanim sredstvima). <p></strong>
    <p><strong>Vjerovnik koji je znao za postojeću blokadu računa svojeg dužnika može biti kazneno odgovoran (za kazneno djelo prijevare u
    gospodarskom poslovanju te pomaganju u pogodovanju vjerovnika) ukoliko unatoč izričitoj zabrani ipak sklopi
    ugovor o obračunskom plaćanju u cilju naplate svojeg potraživanja prije drugih
    vjerovnika, koji prema redoslijedu naplate s blokiranog računa dužnika imaju prednost
    pri namirenju, a u tom slučaju i odgovara trećima za nastalu štetu.   <p></strong>
    <p><strong>Dužnik (poslovni subjekt) kojemu je blokiran račun odnosno koji ima oznaku zabranu raspolaganja oročenim novčanim sredstvima ne smije svoje obveze plaćati gotovim novcem, plaćati preko institucije za platni promet niti preko ostalih pružatelja platnih usluga u Republici Hrvatskoj, kao niti plaćati ili primati plaćanja preko računa otvorenog kod pružatelja platnih usluga u inozemstvu, a ne smije niti preusmjeravati novčane i financijske tijekove na drugu osobu niti primati uplate i isplaćivati novčana sredstva na račune drugih osoba.</strong><p>
    <h5>PRAVNA OSNOVA</h5>
    <p>Zakon o obveznim odnosima.</p>
  `,

  sides: [
    {
      prefix: "ASIGNANT (UPUTITELJ):",
      signature: "ASIGNANT (UPUTITELJ):",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      delimiter: "i"
    },
    {
      prefix: "\r\nASIGNAT (UPUĆENIK):",
      signature: "ASIGNAT (UPUĆENIK):",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }],
      delimiter: "i"
    },
    {
      prefix: "\r\nASIGNATAR (PRIMATELJ UPUTE):",
      signature: "ASIGNATAR (PRIM. UPUTE)",
      inputs: [{
        type: "input",
        required: true,
        placeholder: "Poslovni subjekt",
      },
      {
        type: "input",
        required: true,
        placeholder: "Ulica i kućni broj",
      },
      {
        type: "input",
        required: true,
        placeholder: "Mjesto",
      },
      {
        type: "input",
        required: true,
        placeholder: "OIB",
      },
      {
        type: "input",
        placeholder: "Zastupa",
        inSignature: true,
      },
      {
        type: "input",
        placeholder: "Funkcija",
        inSignature: true,
      }
    ],
    suffix: ","
    },
  ],

  headline: "zaključuju sljedeći",
  title: "UGOVOR O ASIGNACIJI",

  articles: [
    {
      title: "MEĐUSOBNE OBVEZE UGOVORNIH STRANA",
      mandatory: true,
      statements: [
      
        {
          type: "input",
          editable: false,
          mandatory: true,
          parts: [
        
            {type: "text", content: "Ugovorne strane suglasno utvrđuju da ASIGNAT (Upućenik) duguje ASIGNANTU (Uputitelju) iznos od "},
            { type: "input", value: "", required: true,},
            { type: "text", newline:"true", content: "\r\nUgovorne strane suglasno utvrđuju da ASIGNANT (Uputitelj) duguje ASIGNATARU (Primatelju upute) iznos od " },
            { type: "input", value: "", required: true,},
            { type: "text", newline:"true", content: "\r\nUgovorne strane suglasno izjavljuju da su prethodno navedeni iznosi dugovanja navedeni isključivo u svrhu provedbe ovog Ugovora te da međusobna dugovanja eventualno mogu biti i veća, stoga se odriču pozivati da iznos dugovanja naveden u ovom Ugovoru predstavlja cjelokupni iznos međusobnih dugovanja." },

          ],
          }
        ]
      }, 
    {
      title: "PREDMET UGOVORA",
      mandatory: true,
      statements: [
      
        {
          type: "input",
          editable: false,
          mandatory: true,
          parts: [
        
            {type: "text", content: "ASIGNANT (Uputitelj) kao dužnik ASIGNATARA (Primatelja upute), ovlašćuje ASIGNATA (Upućenika) da za njegov račun podmiri obvezu iz ovog Ugovora ASIGNATARU (Primatelju upute) umjesto ASIGNANTU (Uputitelju). "},
            { type: "text", newline:"true", content: "\r\nASIGNAT (Upućenik) bezuvjetno prihvaća uputu iz prethodnog stavka ovog članka." },
          ],
          }
        ]
      }, 
      {
        title: "",
        mandatory: true,
        statements: [
        
          {
            type: "input",
            editable: false,
            mandatory: true,
            parts: [
          
              {type: "text", content: "ASIGNANT (Uputitelj) ovlašćuje ASIGNATARA (Primatelja upute) da u svoje ime primi ispunjenje od ASIGNATA (Upućenika)."},
              { type: "text", newline:"true", content: " \r\nASIGNATAR (Primatelj upute) izjavljuje da pristaje na uputu ASIGNANTA (Uputitelja) iz ovog Ugovora te poziva ASIGNATA (Upućenika) da izvrši uputu." },
            ],
            }
          ]
        }, 
    {
      title: "PRESTANAK OBVEZA",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Obveza ASIGNANTA (Uputitelja) prestaje kada ASIGNAT (Upućenik) podmiri obvezu ASIGNATARU (Primatelju upute)."
        }
      ]
    },
    {
      title: "OBAVIJEST I IZVRŠENJU UPUTE",
      mandatory: true,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: false,
          content: "Nakon što mu ASIGNAT (Upućenik) izvrši uputu, ASIGNATAR (Primatelj upute) će obavijestiti ASIGNANTA (Uputitelja) o smanjenju tražbine prema njemu."
        }
      ]
    },
    {
      title: "PRIMJENA UGOVORA",
      mandatory: false,
      statements: [
        {
          type: "text",
          mandatory: true,
          editable: true,
          content: "Ugovor se primjenjuje od trenutka potpisa ugovornih strana."
        }
      ]
    },
    {
      title: "NADLEŽNOST",
      mandatory: false,
      statements: [
        {
          type: "choice",
          mandatory: true,
          editable: false,
          choices: [
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu ASIGNANTA." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu ASIGNATA." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom prema sjedištu ASIGNATARA." }
              ]
            },
            {
              parts: [
                { type: "text", content: "Svi sporovi koji proizađu ili budu u vezi s ovim Ugovorom rješavati će se pred stvarno nadležnim sudom u " },
                { type: "input", value: "", help: "Upišite mjesno nadležni sud. Npr. ...sudom u Zagrebu; ...sudom u Splitu i sl..", required: true },
              ]
            }
          ],
        }
      ]
    },
    {
      title: 'PRIMJERCI UGOVORA',
      mandatory: false,
      statements: [
          {
              type: 'text',
              required: false,
              mandatory: true,
              editable: true,
              content: 'Ovaj Ugovor sastavljen je u 3 (tri) primjerka, od kojih svaka ugovorna strana zadržava po 1 (jedan) primjerak.',
              value: '',
          }],
    },
  {
    mandatory: true,
    static: true,
    type: 2, // date and place
    statements: [
      {
        type: "input",
        mandatory: true,
        parts: [
          {
            type: "text",
            content: "U"
          },
          {
            type: "input",
            value: "",
            placeholder: "Upišite mjesto.",
            required: true,
          },
          {
            type: "text",
            content: ", dana"
          },
          {
            type: "date",
            value: new Date(),
            required: true
          },
          {
            type: "text",
            content: "godine."
          }
        ]
      },
    ]
  },
    {
      mandatory: true,
      static: true,
      type: 3,  // signatures
      statements: [],
    },
  ],
}; 


// WEBPACK FOOTER //
// C:/Projects/milic/self-legal/src/app/contracts/26_ugovor_o_asignaciji.ts